import { useContext } from 'react';
import PropTypes from 'prop-types';

import { MarkAsShippedContext } from '../../../context';

const Recipient = ({ fulfillmentPlanId }) => {
  const {
    fulfillmentPlans: { [fulfillmentPlanId]: { recipient } = {} },
  } = useContext(MarkAsShippedContext);

  return recipient;
};

Recipient.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default Recipient;
